export default "__VITE_ASSET__GKHw_hl5__"